import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { saveAs, encodeBase64 } from '@progress/kendo-file-saver';
import { State } from '@progress/kendo-data-query';
import { GridComponent } from '@progress/kendo-angular-grid';
import { AttachmentBus } from '@app/cp/shared/models/AttachmentBus';
import { QuoteService } from '@app/cp/shared/services/quote.service';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { CDocument } from '@app/cp/shared/models/CDocument';
import { BaseGridUIComponent } from '@app/cp/shared/base-components/base-grid-ui.component';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { FileInfo } from '@progress/kendo-angular-upload';
import { MediaService } from '@app/cp/shared/services/media.service';
import { FeatureFlagService } from '@app/cp/shared/services/feature-flag.service';

@Component({
    selector: 'job-attachments',
    templateUrl: './job-attachments.component.html',
    styleUrls: ['./job-attachments.component.scss'],
    standalone: false
})
export class JobAttachmentsComponent extends BaseGridUIComponent<AttachmentBus, null, QuoteService> {

    constructor(globals: GlobalsService, svc_data: QuoteService, private svc_media: MediaService, private sanitizer: DomSanitizer) {
        super(globals);
        this.svc_data = svc_data;
    }

    active: boolean = false;
    documentData: any = "";
    documentDataURL: any;
    document: CDocument;
    hide() {
        this.active = false;
    }
    view(data: AttachmentBus) {
        this.svc_data.getDocument(data.id).subscribe(data => {
            this.document = new CDocument(data);
            this.documentData = this.sanitizer.bypassSecurityTrustResourceUrl("data:" + this.document.mimeType + ";base64," + data.documentB64String); //"data:application/pdf;base64," +data.documentB64String); //"data:application/pdf;base64," + data.document);

            var binary = atob(data.documentB64String.replace(/\s/g, ''));
            var len = binary.length;
            var buffer = new ArrayBuffer(len);
            var view = new Uint8Array(buffer);
            for (var i = 0; i < len; i++) {
                view[i] = binary.charCodeAt(i);
            }

            this.documentDataURL = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([view], { type: "application/pdf" })));
            this.active = true;
            //window.open(this.document);
        });
    }
    download(data: AttachmentBus) {
        if (!data.id) {
            this.globals.notifyError("No document id found. Canceling download", true);
            return;
        }
        this.svc_data.getDocument(data.id).subscribe(
            {
                next:
                    data => {
                        this.document = new CDocument(data);
                        let downloadData = "data:" + this.document.mimeType + ";base64," + data.document;
                        saveAs(downloadData, this.document.fileName);
                    },
                error: err => {
                    console.error(err);
                    this.globals.notifyError("Error downloading document: " + err.message, true);
                }
        });
    }
    files: Array<FileInfo> = [];
    uploadSaveUrl: string = "http://localhost:53158/api/media/upload";//"http://18.188.111.206/cpiapi/api/media/upload";
    uploadRemoveUrl: string;
    uploadRestrictions: any;

    selectEventHandler(e: any) {
        this.files = e.files;
        this.svc_media.upload(this.files).subscribe(datqa => {
        });
    }
    clearEventHandler(e: any) {

    }
    removeEventHandler(e: any) {

    }
    completeEventHandler(e: any) {

    }
}

